import React, { useState } from 'react';

const StartOverButton = ({ onConfirm, top = 70, side = 'left' }) => {
  const [asking, setAsking] = useState(false);

  return (
    <>
      <button
        onClick={() => setAsking(true)}
        title="Start over"
        style={{
          position: 'absolute',
          top,
          [side]: 16,
          zIndex: 30,
          background: '#E53935',
          border: '3px solid #B71C1C',
          borderBottom: '5px solid #B71C1C',
          borderRadius: 30,
          padding: '8px 16px',
          fontFamily: "'Fredoka One', cursive",
          fontSize: 16,
          color: 'white',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          transition: 'transform 0.15s ease',
        }}
        onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
        onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        Start over
      </button>

      {asking && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.45)',
            zIndex: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
          }}
          onClick={() => setAsking(false)}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: 'white',
              border: '3px solid #1F93BA',
              borderRadius: 24,
              padding: '24px 28px 22px',
              maxWidth: 420,
              width: '100%',
              boxShadow: '0 8px 28px rgba(0,0,0,0.25)',
              textAlign: 'center',
            }}
          >
            <div style={{ fontFamily: "'Fugaz One',cursive", fontSize: 26, color: '#1a1a1a', marginBottom: 10 }}>
              Start over?
            </div>
            <p style={{ fontFamily: "'Nunito',sans-serif", fontSize: 18, fontWeight: 800, color: '#333', lineHeight: 1.4, margin: '0 0 20px' }}>
              This erases all your progress so you can play from the beginning.
            </p>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 14 }}>
              <button
                onClick={() => setAsking(false)}
                style={{
                  background: '#FE8340',
                  border: '3px solid #CE600A',
                  borderBottom: '5px solid #CE600A',
                  borderRadius: 30,
                  padding: '10px 22px',
                  fontFamily: "'Fredoka One', cursive",
                  fontSize: 16,
                  color: 'white',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={() => { setAsking(false); onConfirm(); }}
                style={{
                  background: '#F819E7',
                  border: '3px solid #BB10AE',
                  borderBottom: '5px solid #BB10AE',
                  borderRadius: 30,
                  padding: '10px 22px',
                  fontFamily: "'Fredoka One', cursive",
                  fontSize: 16,
                  color: 'white',
                  cursor: 'pointer',
                }}
              >
                Start over
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StartOverButton;
